import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toggle"
export default class extends Controller {
  static targets = ["fields", "arrowImg"];

  showFields() {
    this.fieldsTargets.forEach((field) => {
      field.classList.toggle("d-none");
      if(this.hasArrowImgTarget) {
        this.arrowImgTarget.classList.toggle('toggle-btn-close')
      }
    })
  }
}
